import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 0.2fr 0.2fr 0.2fr;
  row-gap: 1rem;
  column-gap: 2rem;
  margin-bottom: 0.7rem;
`;

export const Map = styled.div``;

export const AddButton = styled.button`
  background: none;
  width: 320px !important;
  margin-left: auto !important;
  color: var(--primary);
`;
